// extracted by mini-css-extract-plugin
module.exports = {"button":"_3ygicnuc3GdF","button_outlined":"_3e28Q3aCkhCF"};